function confirmPasswordValidator(input, password) {
  const isValid = input === password ? true : false;

  return isValid;
}

export default confirmPasswordValidator;
